import CaseProcessingComp from "../../../Components/AdminComponents/SuperUser/CaseProcessingComp";

const CaseProcessing = () => {
  return <CaseProcessingComp />;
};

export default CaseProcessing;
